import React from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Link,
    IconButton,
    Divider,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)',
                color: 'white',
                py: { xs: 6, md: 8 },
                mt: 'auto',
                boxShadow: '0 -8px 32px rgba(255,107,107,0.10)',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={6}>
                    {/* Logo et description */}
                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', letterSpacing: 1, mb: 2, textShadow: '0 4px 24px #E53E3E99, 0 1px 0 #fff', background: 'linear-gradient(90deg, #fff 30%, #FF6B6B 70%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textAlign: { xs: 'center', md: 'left' } }}>
                            Pérou Sports
                        </Typography>
                        <Typography variant="body2" paragraph sx={{ mb: 3, opacity: 0.92, fontWeight: 500, textAlign: { xs: 'center', md: 'left' } }}>
                            Discover the passion for sports in Peru. Our platform connects you to the most exciting sports events in the country, from football to volleyball, and all sports that vibrate our nation.
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1.5, mt: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                            <IconButton sx={{ color: 'white', background: 'rgba(255,255,255,0.08)', '&:hover': { color: '#FF6B6B', background: 'white' }, boxShadow: '0 2px 8px #FF6B6B22', borderRadius: 2 }} aria-label="Facebook">
                                <FacebookIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'white', background: 'rgba(255,255,255,0.08)', '&:hover': { color: '#FF6B6B', background: 'white' }, boxShadow: '0 2px 8px #FF6B6B22', borderRadius: 2 }} aria-label="Twitter">
                                <TwitterIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'white', background: 'rgba(255,255,255,0.08)', '&:hover': { color: '#FF6B6B', background: 'white' }, boxShadow: '0 2px 8px #FF6B6B22', borderRadius: 2 }} aria-label="Instagram">
                                <InstagramIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'white', background: 'rgba(255,255,255,0.08)', '&:hover': { color: '#FF6B6B', background: 'white' }, boxShadow: '0 2px 8px #FF6B6B22', borderRadius: 2 }} aria-label="YouTube">
                                <YouTubeIcon />
                            </IconButton>
                        </Box>
                    </Grid>

                    {/* Liens rapides */}
                    <Grid item xs={6} md={2} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 2, textAlign: { xs: 'center', md: 'left' } }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
                            <Link href="/" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Home
                            </Link>
                            <Link href="/events" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Events
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                About
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Contact
                            </Link>
                        </Box>
                    </Grid>

                    {/* Sports */}
                    <Grid item xs={6} md={2} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 2, textAlign: { xs: 'center', md: 'left' } }}>
                            Sports
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Football
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Basketball
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Volleyball
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Tennis
                            </Link>
                            <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                                Martial Arts
                            </Link>
                        </Box>
                    </Grid>

                    {/* Contact */}
                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 2, textAlign: { xs: 'center', md: 'left' } }}>
                            Contact
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.2, alignItems: { xs: 'center', md: 'flex-start' } }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <LocationOnIcon sx={{ fontSize: 22, color: '#fff', background: '#FF6B6B', borderRadius: 1, p: 0.5, mr: 1 }} />
                                <Typography variant="body2" sx={{ opacity: 0.92, fontWeight: 500 }}>
                                    Av. Arequipa 1234, Lima, Peru
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <PhoneIcon sx={{ fontSize: 22, color: '#fff', background: '#FF6B6B', borderRadius: 1, p: 0.5, mr: 1 }} />
                                <Typography variant="body2" sx={{ opacity: 0.92, fontWeight: 500 }}>
                                    +51 1 234 5678
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <EmailIcon sx={{ fontSize: 22, color: '#fff', background: '#FF6B6B', borderRadius: 1, p: 0.5, mr: 1 }} />
                                <Typography variant="body2" sx={{ opacity: 0.92, fontWeight: 500 }}>
                                    info@perousports.pe
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 5, borderColor: 'rgba(255,255,255,0.18)' }} />

                {/* Copyright */}
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                    <Typography variant="body2" sx={{ opacity: 0.92, fontWeight: 500, textAlign: { xs: 'center', md: 'left' } }}>
                        © 2024 Pérou Sports. All rights reserved.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                        <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.95rem', opacity: 0.92, fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                            Privacy Policy
                        </Link>
                        <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.95rem', opacity: 0.92, fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                            Terms of Service
                        </Link>
                        <Link href="#" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.95rem', opacity: 0.92, fontWeight: 500, '&:hover': { color: '#fff', textShadow: '0 0 8px #FF6B6B' } }}>
                            Legal Notice
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer; 